import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './components/layout/MainLayout';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import AdminDashboard from './pages/AdminDashboard';
import ArchitectureDashboard from './pages/ArchitectureDashboard';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import LockedDashboard from './pages/LockedDashboard';
import Gallery from './components/Gallery';
import TrialLayout from './layouts/TrialLayout';
import ArchitectureGalleryPage from './pages/ArchitectureGalleryPage';
import AxesLayout from './layouts/AxesLayout';
import InteriorLayout from './layouts/InteriorLayout';
import MyPlansGallery from './pages/MyPlansGallery';

// Placeholder component for Router Outlet
const EditorTool = () => null;

const App: React.FC = () => {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/locked" element={<LockedDashboard />} />
                    <Route
                        path="/admin"
                        element={
                            <ProtectedRoute allowedRoles={['superadmin']}>
                                <AdminDashboard />
                            </ProtectedRoute>
                        }
                    />

                    {/* The New Nano Banana Suite at /app */}
                    <Route
                        path="/app"
                        element={
                            <ProtectedRoute>
                                <MainLayout />
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<Navigate to="architecture" replace />} />
                        <Route path="render-bridge" element={<EditorTool />} />
                        <Route path="lens" element={<EditorTool />} />
                        <Route path="magic-touch" element={<EditorTool />} />
                        <Route path="refiner" element={<EditorTool />} />

                        <Route path="gallery" element={<Gallery />} />
                    </Route>

                    {/* Architecture Workspace */}
                    <Route
                        path="/app/architecture"
                        element={
                            <ProtectedRoute>
                                <ArchitectureDashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/app/architecture/gallery"
                        element={
                            <ProtectedRoute>
                                <ArchitectureGalleryPage />
                            </ProtectedRoute>
                        }
                    />

                    {/* Interior Designer — Standalone, bypasses MainLayout */}
                    <Route
                        path="/app/interior"
                        element={
                            <ProtectedRoute>
                                <InteriorLayout />
                            </ProtectedRoute>
                        }
                    />

                    {/* Axes — Standalone, bypasses MainLayout like Architecture */}
                    <Route
                        path="/app/axes"
                        element={
                            <ProtectedRoute>
                                <AxesLayout />
                            </ProtectedRoute>
                        }
                    />

                    {/* My Plans Gallery */}
                    <Route
                        path="/app/my-plans"
                        element={
                            <ProtectedRoute>
                                <MyPlansGallery />
                            </ProtectedRoute>
                        }
                    />

                    {/* Trial Route - No Authentication Required */}
                    <Route path="/trial" element={<TrialLayout />}>
                        <Route index element={<Navigate to="render-bridge" replace />} />
                        <Route path="render-bridge" element={<EditorTool />} />
                        <Route path="lens" element={<EditorTool />} />
                        <Route path="magic-touch" element={<EditorTool />} />
                        <Route path="refiner" element={<EditorTool />} />
                        <Route path="gallery" element={<Gallery />} />
                    </Route>
                </Routes>
            </Router>
        </AuthProvider>
    );
};

export default App;
